import { Component, computed, inject, input } from '@angular/core';
import { EnergyInterfacesStore } from '../../../energy-interfaces/stores/energy-interfaces.store';
import { getLocations, SupplierContractData } from '../../stores/supplier-contracts.store';
import { LocationNamePipe } from '../../../locations/pipes/location-name-pipe';
import { Badge } from 'excellence-ui';
import { LocationsStore } from '../../../locations/store/locations.store';
import { isNotNull } from '../../../../core/helper/type-helper';

@Component({
  selector: 'app-supplier-contract-locations',
  imports: [LocationNamePipe, Badge],
  templateUrl: './supplier-contract-locations.html',
})
export class SupplierContractLocations {
  private energyInterfacesStore = inject(EnergyInterfacesStore);
  private locationsStore = inject(LocationsStore);

  supplierContract = input.required<SupplierContractData>();

  protected locations = computed(() => {
    const ids = getLocations(
      this.supplierContract(),
      this.energyInterfacesStore.energyInterfaces() ?? [],
    );
    const allLocations = this.locationsStore.locations() ?? [];
    return ids
      .map((id) => allLocations.find((location) => location.id === id)?.data)
      .filter(isNotNull);
  });
}
